export default {
  masterChef: { // https://github.com/1bch/pancake-farm/blob/master/contracts/MasterChef.sol
    10001: '0x85118d1eE9232d10583554c0Eb6D118fa5336F9c',
    10000: '0xeC0A7496e66a206181034F86B261DDDC1A2c406E',
  },
  sousChef: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBED2',
    10000: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBED2',
  },
  lotteryV2: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEC3',
    10000: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBED3',
  },
  multiCall: { // https://github.com/1bch/pancake-farm/blob/master/contracts/libs/Multicall2.sol
    10001: '0x41dBd137A2791da77d84f8C206DFbE7D5f0d8b72',
    10000: '0x5aD4Ff700732E1997ce338c4709a934f2B7cA406',
  },
  pancakeProfile: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEC5',
    //10000: '0x313FC0bC2EB76935F6c9F7bA6771C7B856A050d0', // old test 1
    10000: '0xd9f9a5884E830bFf9157983d9e4f4EB8E986556F', // new test 1
    //10000: '0x96738bE1Cae224f0864F131339832A9530F41435', // new test 3
  },
  pancakeRabbits: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEC6',
    //10000: '0x0fbeE37155cAc2E44E076329B437b24A44a18e28', // old test 1
    10000: '0x79d5998Df3DAf56A55b4a5f3bA57E7FD4034CdDE', // new test 1
    //10000: '0xD38a62F5C7F5B3AB9057Ce4ef3316D6D624087C6', // new test 3
  },
  bunnyFactory: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEC7',
    //10000: '0x02807b3D2D6002A4b85d352133BBF8CD680D92Db', // old test 1
    10000: '0xf8b0e15Ae8643F69F524931c28dF7A454a5F49F7', // new test 2
    //10000: '0x155344F82e32C7c679BdfEba7579859f186D757B', // new test 3
  },
  claimRefund: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEC8',
    10000: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBED8',
  },
  pointCenterIfo: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEC9',
    10000: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBED9',
  },
  bunnySpecial: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBECA',
    10000: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEDA',
  },
  tradingCompetition: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBECB',
    10000: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEDB',
  },
  tradingCompetitionV2: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBECC',
    10000: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEDC',
  },
  easterNft: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBECC',
    10000: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEDC',
  },
  cakeVault: { // https://github.com/1bch/1bch-vault/blob/main/contracts/CakeVault.sol
    10001: '0x01dA3E12157dCBAe072B185FA81e7bbDe248083a',
    10000: '0xFa2cA96eA159d53bb638441FE1622657DB50eB18',
  },
  ifoPool: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBECD',
    10000: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEDD',
  },
  predictions: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBECE',
    10000: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEDE',
  },
  chainlinkOracle: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBECF',
    10000: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEDF',
  },
  bunnySpecialCakeVault: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEE1',
    10000: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEF1',
  },
  bunnySpecialPrediction: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEE2',
    10000: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEF2',
  },
  bunnySpecialLottery: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEE3',
    10000: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEF3',
  },
  farmAuction: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEE4',
    10000: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEF4',
  },
  AnniversaryAchievement: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEE5',
    10000: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEF5',
  },
  nftMarket: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEE6',
    //10000: '0xFB72cCA86BdA6cF30b591c0cDc223B06d35CC6E6', // old test 1
    //10000: '0x5fDd7f3950f3eB8dc719C457B9da9BE6c6CA5663', // 1bch
    10000: '0x36C0e29A88704AC7a9BEA636b2DeD2DD242a884b', // 1bch, 30%
  },
  nftSale: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEE7',
    10000: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEF7',
  },
  pancakeSquad: {
    10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEE8',
    10000: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEF8',
  }
  
  /*masterChef: {
    97: '0x1d32c2945C8FDCBc7156c553B7cEa4325a17f4f9',
    56: '0x73feaa1eE314F8c655E354234017bE2193C9E24E',
  },
  sousChef: {
    97: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
    56: '0x6ab8463a4185b80905e05a9ff80a2d6b714b9e95',
  },
  lotteryV2: {
    97: '0x5790c3534F30437641541a0FA04C992799602998',
    56: '0x5aF6D33DE2ccEC94efb1bDF8f92Bd58085432d2c',
  },
  multiCall: {
    56: '0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B',
    97: '0x8F3273Fb89B075b1645095ABaC6ed17B2d4Bc576',
  },
  pancakeProfile: {
    56: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a',
    97: '0x4B683C7E13B6d5D7fd1FeA9530F451954c1A7c8A',
  },
  pancakeRabbits: {
    56: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    97: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
  },
  bunnyFactory: {
    56: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    97: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
  },
  claimRefund: {
    56: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    97: '',
  },
  pointCenterIfo: {
    56: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
    97: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
  },
  bunnySpecial: {
    56: '0xFee8A195570a18461146F401d6033f5ab3380849',
    97: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
  },
  tradingCompetition: {
    56: '0xd718baa0B1F4f70dcC8458154042120FFE0DEFFA',
    97: '0xC787F45B833721ED3aC46E99b703B3E1E01abb97',
  },
  tradingCompetitionV2: {
    56: '0x9b872C05C38A3563393668839659bA336Cc969B2',
    97: '',
  },
  easterNft: {
    56: '0x23c41D28A239dDCAABd1bb1deF8d057189510066',
    97: '0x24ec6962dbe874F6B67B5C50857565667fA0854F',
  },
  cakeVault: {
    56: '0xa80240Eb5d7E05d3F250cF000eEc0891d00b51CC',
    97: '',
  },
  ifoPool: {
    56: '0x1B2A2f6ed4A1401E8C73B4c2B6172455ce2f78E8',
    97: '',
  },
  predictions: {
    56: '0x18B2A687610328590Bc8F2e5fEdDe3b582A49cdA',
    97: '',
  },
  chainlinkOracle: {
    56: '0xD276fCF34D54A926773c399eBAa772C12ec394aC',
    97: '',
  },
  bunnySpecialCakeVault: {
    56: '0x5B4a770Abe7Eafb2601CA4dF9d73EA99363E60a4',
    97: '',
  },
  bunnySpecialPrediction: {
    56: '0x342c99e9aC24157657095eC69CB04b73257e7A9C',
    97: '',
  },
  bunnySpecialLottery: {
    56: '0x24ED31d31C5868e5a96aA77fdcB890f3511fa0b2',
    97: '0x382cB497110F398F0f152cae82821476AE51c9cF',
  },
  farmAuction: {
    56: '0xb92Ab7c1edcb273AbA24b0656cEb3681654805D2',
    97: '0x3F9602593b4f7C67ab045DB51BbDEa94E40fA9Fe',
  },
  AnniversaryAchievement: {
    56: '0x787980da5491118C3cB33B21aB50c8c379D2C552',
    97: '0x981aE96378e770DE44F89cD9175E708f9EDB70a9',
  },
  nftMarket: {
    56: '0x17539cCa21C7933Df5c980172d22659B8C345C5A',
    97: '0x7f9f37ddcaa33893f9beb3d8748c8d6bfbde6ab2',
  },
  nftSale: {
    56: '0x29fE7148636b7Ae0b1E53777b28dfbaA9327af8E',
    97: '0xe486De509c5381cbdBF3e71F57D7F1f7570f5c46',
  },
  pancakeSquad: {
    56: '0x0a8901b0E25DEb55A87524f0cC164E9644020EBA',
    97: '0xfC0c3F11fDA72Cb9A56F28Ec8D44C0ae4B3ABF86',
  },*/
}
